"use client";

import { useEffect } from "react";
import Image from "next/image";

export default function FollowMedhavi() {
  useEffect(() => {
    // Load Elfsight only once
    if (!document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')) {
      const script = document.createElement("script");
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-4">
        {/* Title */}
        <h2 className="text-3xl font-semibold text-center mb-12">
          Follow @medhaviskills
        </h2>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          {/* Facebook */}
          <SocialCard>
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmedhaviskillsuniversity&tabs=timeline&width=340&height=500"
              className="w-full h-[420px] border-0 overflow-hidden"
              scrolling="no"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            />
          </SocialCard>

          {/* YouTube */}
          <SocialCard>
            <div
              className="elfsight-app-86f95fac-5b13-4f43-9e5e-b9e60627741a"
              data-elfsight-app-lazy
            />
          </SocialCard>

          {/* Instagram */}
          <SocialCard>
            <div
              className="elfsight-app-96634644-5e00-4eb7-9d70-ccc28003404a"
              data-elfsight-app-lazy
            />
          </SocialCard>

          {/* LinkedIn */}
          <SocialCard>
            <div
              className="elfsight-app-9077ee1b-f782-474c-980e-50af38d22493"
              data-elfsight-app-lazy
            />
          </SocialCard>
        </div>
      </div>
    </section>
  );
}

/* ---------------- Reusable Card ---------------- */

function SocialCard({ children }) {
  return (
    <div className="rounded-xl border border-gray-200 p-4 bg-white shadow-sm">
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden border">
          <Image
            src="/images/icons/university_icon.png"
            alt="Medhavi Skills University"
            width={24}
            height={24}
            className="object-cover"
          />
        </div>
        <div>
          <h5 className="font-semibold text-sm">Medhavi Skills University</h5>
          <p className="text-xs text-gray-500">@medhaviskills</p>
        </div>
      </div>

      {/* Embed */}
      <div className="w-full overflow-hidden rounded-lg">
        {children}
      </div>
    </div>
  );
}
